import { Avatar } from '@/components/Avatar';
import { MessageWrapper } from '@/features/ChatBotV2/components/MessageWrapper';
import { AttachmentCard } from '@/features/ChatBotV2/components/UploadFiles';
import type { AttachmentType } from '@/features/ChatBotV2/types';
import { useUserData } from '@/hooks/query/useUserData';

export const UserMessage = ({
  prompt,
  attachments = [],
  attachmentsFeedId,
  isReportMessage = false,
}: UserMessageType) => {
  const { data: user } = useUserData();
  return (
    <MessageWrapper
      attachments={
        attachments.length > 0 ? (
          <ul className='flex flex-col items-end gap-2 flex-wrap'>
            {attachments.map((attachment) => (
              <AttachmentCard
                key={attachment.id}
                id={attachment.id}
                name={attachment.name}
                mime_type={attachment.mime_type}
                showRemoveButton={false}
                status={attachment.status}
                feed_id={attachmentsFeedId}
              />
            ))}
          </ul>
        ) : null
      }
      avatar={
        isReportMessage ? null : (
          <Avatar
            size='xs'
            shape='circular'
            className='bg-emerald-900'
            {...(user &&
              user.name && {
                name: user.name,
              })}
          />
        )
      }
      prompt={
        <div
          className={`w-full ${
            isReportMessage
              ? 'text-xl font-medium text-slate-800 pb-2 border-b border-slate-300'
              : ''
          }`}
        >
          {prompt}
        </div>
      }
      variant={isReportMessage ? 'report' : 'default'}
    />
  );
};

type UserMessageType = {
  prompt: string;
  isReportMessage?: boolean;
  attachments?: AttachmentType[];
  attachmentsFeedId?: string;
};
